import React from 'react';
import PropTypes from 'prop-types';
import keyMirror from 'keymirror';
import _ from 'lodash';
import cn from 'classnames';
import Button from 'react-bootstrap/lib/Button';

import t from '../../lib/I18n';
import urls from '../../urls';
import useRouter from '../../helpers/useRouter';
import { AccountPages } from '../../constants/AppConstants';

import Icon from '../general/Icon';

export const ButtonSizes = keyMirror({
    SM: null,
    MD: null,
});

const AlertButton = ({
    className,
    disabled = false,
    hasMatchingAlert = false,
    hideIcon = false,
    hideText = false,
    onClick = _.noop,
    size = ButtonSizes.MD,
    text = t('disruptionAlerts.create.button'),
}) => {
    const router = useRouter();

    const handleClick = hasMatchingAlert
        ? () => router.push(urls.location(AccountPages.ACCOUNT_DISRUPTION_ALERTS))
        : onClick;

    const baseClass = 'create-disruption-alert-btn';
    const classes = cn(baseClass, 'btn-squarish', {
        [`${baseClass}--sm`]: size === ButtonSizes.SM,
        [`${baseClass}--icon-only`]: hideText,
        [`${baseClass}--matching-alert`]: hasMatchingAlert,
    }, className);

    return (
        <Button
            className={classes}
            onClick={handleClick}
            disabled={disabled}
        >
            {!hideIcon && <Icon icon="alert-active" />}
            <span className={hideText && 'sr-only'}>
                {hasMatchingAlert
                    ? t('disruptionAlerts.create.button.matchingAlert')
                    : text
                }
            </span>
        </Button>
    );
};

AlertButton.propTypes = {
    className: PropTypes.string,
    disabled: PropTypes.bool,
    hasMatchingAlert: PropTypes.bool,
    hideIcon: PropTypes.bool,
    hideText: PropTypes.bool,
    onClick: PropTypes.func,
    size: PropTypes.oneOf([_.values(ButtonSizes)]),
    text: PropTypes.string,
};

export default AlertButton;



// WEBPACK FOOTER //
// ./src/components/disruptionAlert/AlertButton.js